// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6353":"a9a07606","9240":"1b233e09"}[chunkId] + ".chunk.css";
};